import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class ChatService {

/* ================= CHAT REQUEST ================= */
  async addRequest(data) {
    const response = await ajaxService.post(`/chat-requests`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  /* ================= FETCHING ================= */

  // Agent: fetch chats by role (queue)
  async fetchChatsByRole(roleId) {
    const res = await ajaxService.get(
      `/chat-requests?role_id=${roleId}`
    );
    return res?.data ?? [];
  }

  // Fetch messages for a chat (agent & customer)
  async fetchMessages(chatId) {
    const res = await ajaxService.get(
      `/chat-requests/${chatId}/messages`
    );
    return Array.isArray(res?.data) ? res.data : [];
  }

  /* ================= MESSAGING ================= */

  // Send text / file / image message
  // async sendMessage(chatId, { message, file }) {
  //   const formData = new FormData();

  //   if (message) formData.append("message", message);
  //   if (file) formData.append("file", file);

  //   const res = await ajaxService.post(
  //     `/chat-requests/${chatId}/messages`,
  //     formData,
  //     { headers: { "Content-Type": "multipart/form-data" } }
  //   );

  //   // SUCCESS → return response directly
  //   if (res?.success) return res;

  //   // VALIDATION ERROR → only then call validationErrors
  //   if (res?.data?.errors) {
  //     return validationErrors(res.data.errors);
  //   }

  //   // UNKNOWN ERROR
  //   throw new Error("Message send failed");
  // }

  async sendMessage(chatId, payload) {

    const res = await ajaxService.post(`/chat-requests/${chatId}/messages`,payload);

    // SUCCESS → return response directly
    if (res?.success) return res;

    // VALIDATION ERROR → only then call validationErrors
    if (res?.data?.errors) {
      return validationErrors(res.data.errors);
    }

    // UNKNOWN ERROR
    throw new Error("Message send failed");
  }


  /* ================= AGENT ACTIONS ================= */

  // Accept chat
  async accept(chatId) {
    return ajaxService.post(
      `/chat-requests/${chatId}/accept`
    );
  }

  // Mute chat for 15 minutes
  async mute(chatId) {
    return ajaxService.post(
      `/chat-requests/${chatId}/mute`
    );
  }

  // Transfer chat to role or agent
  async transfer(chatId, payload) {
    return ajaxService.post(
      `/chat-requests/${chatId}/transfer`,
      payload
    );
  }

  // Resolve / close chat with feedback (agent or customer)
  async resolve(chatId,payload) {
    return ajaxService.post(`/chat-requests/${chatId}/close`,payload);
  }

   // Resolve / close chat with feedback (agent or customer)
  async markRead(chatId) {
    return ajaxService.post(`/chat-requests/${chatId}/mark-read`);
  }
}

const chatService = new ChatService();

export default chatService;
